module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui small modal",
    attrs: {
      "id": "modal-confirm"
    }
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("\n    Please confirm...\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "content",
    domProps: {
      "innerHTML": _vm._s(_vm.payload.message)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('button', {
    staticClass: "ui button",
    on: {
      "click": function($event) {
        _vm.confirm(false)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "ui positive button",
    on: {
      "click": function($event) {
        _vm.confirm(true)
      }
    }
  }, [_vm._v("Yes")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-718d28a6!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/ModalConfirm.vue
// module id = 223
// module chunks = 2